"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { jsx } from "react/jsx-runtime";
import React from "react";
import $ from "jquery";
import _ from "underscore";
import Account from "../api/account";
import Api from "../api/api";
import Auth from "../util/auth";
import fetch from "../util/fetch";
import ApiService from "../services/api_service";
import DataStoreService from "./data_store_service";
import DocumentIndexerService from "./document_indexer_service";
import DocumentsService from "./documents_service";
import get from "./data/get";
import WaitingSpinner from "../components/waiting_spinner";
import { DocumentIndexer } from "./react_indexer";
import {
  GroupedDocumentBrowserModel,
  GroupIDGroupCreator
} from "./grouped_document_browser_model";
import ToDashboardWithFilters from "./ui/to_dashboard_with_filters";
import { isIndexerMode } from "./index_audit_split_mode";
import { Flash } from "../components/flash";
import { maybePrefetchNextFlowModeItem } from "./flow_mode/flow_mode_service";
import CarrierInvoicesStore from "../stores/carrier_invoices_store";
import { fetchDocumentLoadRelationships } from "./helpers/document_load_relationship_fetcher";
import { factorInvoiceWorkflowBatch } from "./flow_mode/dashboard_paths";
import { push, replace } from "./app_history";
function firstPageForGroup(group) {
  return _.first(_.first(group.documents).pages);
}
function documentIsCompleteCreator(documentBatch) {
  const docs = documentBatch.documents;
  if (docs.every((d) => d.type)) {
    return (doc) => {
      const docsForGroup = docs.filter(
        (d) => d.document_group_id === doc.document_group_id
      );
      return docsForGroup.every((d) => d.finished);
    };
  }
  return (doc) => doc.type;
}
function pageIsForMyModel(state, page) {
  if (state.model) {
    return state.model._documentForPage(page);
  }
  return false;
}
function incompleteGroups(props, state) {
  return inIndexerMode(props) ? state.model.indexerGroups() : state.model.incompleteGroups();
}
function hasMore(props, state) {
  const remainingGroups = incompleteGroups(props, state);
  if (remainingGroups.length === 0) {
    return false;
  }
  if (remainingGroups.length > 1) {
    return true;
  }
  return remainingGroups[0] !== state.model.selectedGroup;
}
function inIndexerMode(props) {
  return isIndexerMode(props.location);
}
function showNonInvoiceConfirmPage(props) {
  return Auth._currentUser.account.settings.feature_enable_non_invoice_flow && !inIndexerMode(props);
}
function startPage(props, state, documentBatch) {
  if (state.forceComputeStartPage) {
    return null;
  }
  return startPageFromExistingModel(state) || startPageFromURL(props, documentBatch);
}
function startPageFromExistingModel(state) {
  if (state.model) {
    return state.model.selectedPage;
  }
}
function startPageFromURL(props, documentBatch) {
  const groupId = props.location.query.group_id;
  const invoiceId = props.location.query.invoiceId;
  if (!groupId && !invoiceId) {
    return;
  }
  if (groupId) {
    var query = (d) => {
      return d.document_group_id === parseInt(groupId, 10);
    };
  } else {
    var query = (d) => {
      return d.factor_invoice_id === parseInt(invoiceId, 10) || d.carrier_invoice_id === parseInt(invoiceId, 10);
    };
  }
  const startDoc = _.find(documentBatch.documents, query);
  if (startDoc) {
    return startDoc.pages[0];
  }
}
function logCurrentStateOfBatch(state) {
  console.trace();
  console.log("Document Batch Groups");
  state.documentBatch.document_groups.forEach((group) => {
    console.log("Document group id: " + group.id);
  });
  console.log("\nDocument batch by documents");
  state.documentBatch.documents.forEach((doc) => {
    console.log("Document id: " + doc.id);
    console.log("- Document group id: " + doc.document_group_id);
    console.log(
      "- Document group position (data.group_id): " + doc.data.group_id
    );
    if (doc.pages) {
      doc.pages.forEach((page) => {
        console.log("- Document page id: " + page.id);
      });
    }
  });
}
function redirectToWorkflowPage(props, state) {
  var _a, _b, _c, _d, _e, _f, _g;
  const selectedGroupId = (_b = (_a = state.model) == null ? void 0 : _a.selectedGroup) == null ? void 0 : _b.id;
  const documentGroup = _.findWhere((_c = state.documentBatch) == null ? void 0 : _c.document_groups, {
    id: selectedGroupId
  });
  const factorInvoice = _.findWhere((_d = state.documentBatch) == null ? void 0 : _d.factor_invoices, {
    id: documentGroup == null ? void 0 : documentGroup.factor_invoice_id
  });
  const emailId = (_e = state.documentBatch.email_message) == null ? void 0 : _e.id;
  if ((factorInvoice == null ? void 0 : factorInvoice.id) && emailId) {
    const batchId = state.documentBatch.id;
    const target = factorInvoiceWorkflowBatch(
      batchId,
      emailId,
      factorInvoice.id,
      (_g = (_f = props.location) == null ? void 0 : _f.query) == null ? void 0 : _g.onDone
    );
    replace(target.toString());
    return true;
  }
  return false;
}
function goToLoadAndReturn(props, state, loadId, carrierInvoiceId, isFirstLoad) {
  const newLocation = props.location.query.onDone || "/dashboard";
  const filters = props.location.query.filters;
  const moreGroups = hasMore(props, state);
  const emailId = props.location.query.emailId;
  const next = moreGroups ? props.location.pathname + "?onDone=" + encodeURIComponent(newLocation) : newLocation;
  const invoice = CarrierInvoicesStore.find(carrierInvoiceId);
  let url;
  if (invoice == null ? void 0 : invoice.requires_ltl_reconciliation) {
    url = `/loads/${loadId}/carrier_invoices/${carrierInvoiceId}/ltl-reconcile`;
  } else {
    url = `/index-document-batches/${state.documentBatch.id}/loads/${loadId}/carrier_invoices/${carrierInvoiceId}`;
  }
  push(url, {
    hasMore: moreGroups,
    onDone: next,
    filters,
    emailMessageId: state.documentBatch.email_message.id,
    isFirstLoad,
    emailId
  });
}
function maybeRedirectToWorkflowPage(props, state) {
  var _a, _b;
  if (!Account.useFactorInvoiceWorkflowPage() || ((_b = (_a = props.location) == null ? void 0 : _a.query) == null ? void 0 : _b.forceReact)) {
    return false;
  }
  return redirectToWorkflowPage(props, state);
}
function returnToWorkflowPageAfterForcedStep(props, state) {
  if (!Account.useFactorInvoiceWorkflowPage()) {
    return false;
  }
  return redirectToWorkflowPage(props, state);
}
class DocumentIndexerPage extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      documentLoadRelationships: []
    });
    __publicField(this, "mounted", false);
    __publicField(this, "pageReplaced", (args, page) => {
      if (page && pageIsForMyModel(this.state, page)) {
        var currentPage = this.state.model.selectedPage;
        const isUpdatedVersionOfCurrentPage = currentPage && currentPage.document_id === page.document_id && currentPage.number === page.number;
        if (isUpdatedVersionOfCurrentPage) {
          this.updateExistingBatch(page);
        } else {
          this.updateExistingBatch(currentPage);
        }
      }
    });
    __publicField(this, "factorInvoiceUpdatedCallback", () => {
      if (this.state.documentBatch) {
        this.updateExistingBatch();
      }
    });
    __publicField(this, "updateExistingBatch", (page) => {
      this.updateDocumentBatch(this.state.documentBatch, page);
      this.forceUpdate();
    });
    __publicField(this, "documentsExceptionAddedCallback", () => {
      this.setState({ forceComputeStartPage: true });
      return this.reloadDocumentBatch();
    });
    __publicField(this, "reloadDocumentBatch", () => {
      return DocumentsService.getUncachedDocumentBatch(
        this.state.documentBatch.id
      ).then(this.updateDocumentBatch);
    });
    __publicField(this, "onMergeDocumentBatches", () => {
      const page = this.state.model.selectedPage;
      DocumentsService.getUncachedDocumentBatch(this.state.documentBatch.id).then(
        (documentBatch) => {
          this.updateDocumentBatch(documentBatch, page);
        }
      );
    });
    __publicField(this, "factorInvoiceAbandonedCallback", () => {
      this.setState({ forceComputeStartPage: false });
      Promise.resolve().then(() => {
        return DocumentsService.getUncachedDocumentBatch(
          this.state.documentBatch.id
        );
      }).then((batch) => {
        return this.updateDocumentBatch(batch);
      }).catch(console.error);
    });
    __publicField(this, "documentBatchUpdatedCallback", (event, documentBatch) => {
      if (documentBatch.id === this.state.documentBatch.id) {
        this.updateDocumentBatch(documentBatch);
      }
    });
    __publicField(this, "updateDocumentBatch", (documentBatch, page) => {
      if (this.mounted) {
        const model = new GroupedDocumentBrowserModel(
          new GroupIDGroupCreator(
            documentBatch.documents,
            documentBatch.document_groups
          ),
          documentIsCompleteCreator(documentBatch),
          page || startPage(this.props, this.state, documentBatch)
        );
        const leftDocumentModel = new GroupedDocumentBrowserModel(
          new GroupIDGroupCreator(
            documentBatch.documents,
            documentBatch.document_groups
          ),
          documentIsCompleteCreator(documentBatch),
          page || startPage(this.props, this.state, documentBatch)
        );
        const indexerService = DocumentIndexerService(
          documentBatch,
          DataStoreService,
          Api.Account,
          this.props.location
        );
        this.setState({
          model,
          leftDocumentModel,
          documentIndexerService: indexerService,
          documentBatch,
          forceComputeStartPage: false,
          loaded: true
        });
        return documentBatch;
      }
    });
    __publicField(this, "updateDocumentLoadRelationships", (loadStateIds) => {
      if (!this.mounted) {
        return;
      }
      const documentIds = this.state.documentBatch.documents.map(
        (doc) => doc.id
      );
      fetchDocumentLoadRelationships(
        documentIds,
        loadStateIds,
        (relationships) => {
          if (this.mounted) {
            this.setState({
              documentLoadRelationships: relationships
            });
          }
        }
      );
    });
    __publicField(this, "content", () => {
      if (this.state.loaded) {
        if (this.state.documentBatch.documents.length == 0) {
          Flash.alert("Document batch failed to load: Group has 0 documents", {
            timeout: 1e8
          });
          return;
        }
        if (this.state.documentBatch.documents.some(
          (doc) => !doc.pages || doc.pages.length === 0
        )) {
          logCurrentStateOfBatch(this.state);
          Flash.alert("Document batch failed to load: Document has 0 pages", {
            timeout: 1e8
          });
          return;
        }
        return /* @__PURE__ */ jsx(
          DocumentIndexer,
          {
            hasMore: hasMore(this.props, this.state),
            model: this.state.model,
            leftDocumentModel: this.state.leftDocumentModel,
            documentIndexerService: this.state.documentIndexerService,
            documentBatch: this.state.documentBatch,
            carrier: get.carrierPromise(this.state.documentBatch),
            documentsExceptionAddedCallback: this.documentsExceptionAddedCallback,
            factorInvoiceAbandonedCallback: this.factorInvoiceAbandonedCallback,
            onMergeDocumentBatches: this.onMergeDocumentBatches,
            allowsEditing: true,
            assignCurrentGroupToLoadAndInvoiceId: this.assignCurrentGroupToLoadAndInvoiceId,
            assignCurrentGroupToLoad: this.assignCurrentGroupToLoad,
            location: this.props.location,
            forceComputeStartPage: this.forceComputeStartPage,
            skipStep: this.goToNextGroupOrDashboard,
            returnToWorkflowPageAfterForcedStep: () => returnToWorkflowPageAfterForcedStep(this.props, this.state),
            maybeRedirectToWorkflowPage: () => maybeRedirectToWorkflowPage(this.props, this.state),
            reloadDocumentBatch: this.reloadDocumentBatch,
            updateDocumentLoadRelationships: this.updateDocumentLoadRelationships,
            documentLoadRelationships: this.state.documentLoadRelationships
          }
        );
      }
      return /* @__PURE__ */ jsx("div", {});
    });
    __publicField(this, "goToNextGroupOrDashboard", () => {
      const moreGroups = hasMore(this.props, this.state);
      if (moreGroups) {
        if (inIndexerMode(this.props)) {
          const nextPage = firstPageForGroup(
            _.first(incompleteGroups(this.props, this.state))
          );
          this.state.model.selectPage(nextPage);
        } else {
          this.setState({ forceComputeStartPage: true });
          return this.reloadDocumentBatch();
        }
      } else {
        ToDashboardWithFilters(this.props.location);
      }
    });
    __publicField(this, "assignCurrentGroupToLoadAndInvoiceId", (loadStateId, carrierInvoiceId, carrierInvoice, carrierID, isFirstLoad, assignCustomerOnlyDocuments, shipmentDocumentSelections, deliveryDocumentSelections) => {
      this.setState({ waiting: true });
      const docs = this.state.model.activeDocuments();
      const shipmentDocumentSelectionIds = shipmentDocumentSelections == null ? void 0 : shipmentDocumentSelections.map(
        (shipmentDocumentSelection) => {
          const documentIds = shipmentDocumentSelection.documents.map(
            (doc) => doc.id
          );
          const shipmentId = shipmentDocumentSelection.shipment.tms_shipment_id;
          return { document_ids: documentIds, shipment_id: shipmentId };
        }
      );
      return ApiService.addErrorHandler(
        fetch("/api/documents/assign_documents_to_new_or_existing_invoice", {
          data: {
            load_state_id: loadStateId,
            carrier_id: carrierID,
            carrier_invoice_id: carrierInvoiceId,
            carrier_invoice: carrierInvoice,
            document_ids: docs.map((d) => d.id),
            assign_customer_only_documents: assignCustomerOnlyDocuments,
            shipment_document_selections: shipmentDocumentSelectionIds,
            delivery_document_selections: deliveryDocumentSelections
          },
          method: "post"
        }),
        null,
        { caller: "DocumentIndexerPage.assignCurrentGroupToLoadAndInvoiceId" }
      ).then((data) => {
        DataStoreService.updateStores(data);
        if (inIndexerMode(this.props)) {
          this.goToNextGroupOrDashboard();
        } else {
          goToLoadAndReturn(
            this.props,
            this.state,
            data.load_state_id,
            data.carrier_invoice_id,
            isFirstLoad
          );
        }
      }).catch((error) => {
        this.setState({ waiting: false });
        return error;
      });
    });
    __publicField(this, "assignCurrentGroupToLoad", (loadStateId, carrierID, deliveryDocumentSelections) => {
      this.setState({ waiting: true });
      const docs = this.state.model.activeDocuments();
      const navigateToNonInvoiceConfirmPage = () => {
        const url = `/index-document-batches/${this.state.documentBatch.id}/loads/${loadStateId}/confirm`;
        const onDone = this.props.location.query.onDone || "/app/dashboard";
        const params = hasMore(this.props, this.state) ? {} : { onDone };
        push(url, params);
      };
      return ApiService.addErrorHandler(
        fetch("/api/documents/assign_documents_to_non_invoice_load", {
          data: {
            load_state_id: loadStateId,
            carrier_id: carrierID,
            document_ids: docs.map((d) => d.id),
            delivery_document_selections: deliveryDocumentSelections
          },
          method: "post"
        }),
        null,
        { caller: "DocumentIndexerPage.assignCurrentGroupToLoad" }
      ).then((data) => {
        DataStoreService.updateStores(data);
        return showNonInvoiceConfirmPage(this.props) ? navigateToNonInvoiceConfirmPage() : this.goToNextGroupOrDashboard();
      }).catch((error) => {
        this.setState({ waiting: false });
        return error;
      });
    });
    __publicField(this, "forceComputeStartPage", () => {
      this.setState({ forceComputeStartPage: true }, this.updateExistingBatch);
    });
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.params.batchId != this.props.params.batchId) {
      DocumentsService.getUncachedDocumentBatch(nextProps.params.batchId).then(
        this.updateDocumentBatch
      );
    }
  }
  componentWillMount() {
    const batchID = this.props.params.batchId;
    DocumentsService.getUncachedDocumentBatch(batchID).then(this.updateDocumentBatch).then(() => {
      var _a, _b, _c, _d;
      const email = (_a = this.state.documentBatch) == null ? void 0 : _a.email_message;
      if (((_c = (_b = this.props.location) == null ? void 0 : _b.query) == null ? void 0 : _c.fromQueue) === "new" && ((_d = Auth.getCurrentUser()) == null ? void 0 : _d.managed_indexer) && ((email == null ? void 0 : email.indexed) || (email == null ? void 0 : email.completed_at))) {
        Flash.alert("This item is no longer in the New Queue.");
        ToDashboardWithFilters(this.props.location);
        return;
      }
      if (maybeRedirectToWorkflowPage(this.props, this.state)) {
        return;
      }
      $(DataStoreService).on(
        "DataStoreService:documentGroupUpdated",
        _.partial(this.updateExistingBatch, null)
      );
      $(DataStoreService).on(
        "DataStoreService:documentBatchUpdated",
        this.documentBatchUpdatedCallback
      );
      $(DataStoreService).on(
        "DataStoreService:documentPageReplaced",
        this.pageReplaced
      );
      $(DataStoreService).on(
        "DataStoreService:factorInvoiceUpdated",
        this.factorInvoiceUpdatedCallback
      );
    });
  }
  componentDidMount() {
    return __async(this, null, function* () {
      this.mounted = true;
      yield maybePrefetchNextFlowModeItem(this.props.location);
    });
  }
  componentWillUnmount() {
    this.mounted = false;
    $(DataStoreService).off(
      "DataStoreService:documentGroupUpdated",
      this.updateExistingBatch
    );
    $(DataStoreService).off(
      "DataStoreService:documentBatchUpdated",
      this.documentBatchUpdatedCallback
    );
    $(DataStoreService).off(
      "DataStoreService:documentPageReplaced",
      this.updateExistingBatch
    );
    $(DataStoreService).off(
      "DataStoreService:factorInvoiceUpdated",
      this.factorInvoiceUpdatedCallback
    );
  }
  render() {
    return /* @__PURE__ */ jsx(
      WaitingSpinner,
      {
        "data-component": "DocumentIndexerPage",
        when: this.state.waiting || !this.state.loaded,
        children: this.content()
      }
    );
  }
}
export default DocumentIndexerPage;
